
<!--<script src="https://cdn.anychart.com/releases/8.12.0/js/anychart-base.min.js" type="text/javascript"></script>-->


<template>
    <v-container>
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <div style="padding-top: 80px">
            <v-card elevation="6" class="base-card-container pa-0 mt-4">
                <v-card-title class="pa-5 pb-3 primary">
                    <p style="color: white;">Búsqueda NPS</p>

                </v-card-title>
                <v-form ref="formBus">
                    <v-card-text>
                        <v-row justify="center">
                            <v-col cols="12" sm="6" md="6">

                                <div>
                                    <span style="font-weight: bold;">Tipo de Encuesta</span>
                                    <v-select outlined
                                              dense
                                              :items="encuestasArray"
                                              v-model="datos.tipoencuesta"
                                              no-data-text="Seleccione el Tipo"
                                              item-text="egdesc"
                                              item-value="egid"
                                              placeholder="Seleccione una opción"
                                              :rules="ruleSelect"
                                              return-object>

                                    </v-select>
                                </div>

                                <div>
                                    <span style="font-weight: bold;">Cliente</span>
                                    <v-autocomplete v-model="datos.cliente"
                                                    :items="clientesArray"
                                                    outlined
                                                    dense
                                                    filled
                                                    chips
                                                    small-chips
                                                    no-data-text="Sin datos"
                                                    color="blue-grey lighten-2"
                                                    item-text="clnombrecorto"
                                                    item-value="clclave"
                                                    return-object
                                                    multiple>
                                        <template v-slot:selection="data">
                                            <v-chip v-bind="data.attrs"
                                                    small
                                                    :input-value="data.selected"
                                                    close
                                                    @click="data.select"
                                                    @click:close="remove(data.item,data.index)">
                                                {{ data.item.clnombrecorto }}
                                            </v-chip>
                                        </template>
                                        <template v-slot:item="data">
                                            <template v-if="typeof data.item !== 'object'">
                                                <v-list-item-content v-text="data.item"></v-list-item-content>
                                            </template>
                                            <template v-else>
                                                <v-list-item-content>
                                                    <v-list-item-title v-html="data.item.clnombrecorto"></v-list-item-title>
                                                </v-list-item-content>
                                            </template>
                                        </template>
                                    </v-autocomplete>
                                </div>

                                <div>
                                    <span style="font-weight: bold;">Gerencias</span>
                                    <v-autocomplete v-model="datos.gerencia"
                                                    :items="gerenciasArray"
                                                    outlined
                                                    dense
                                                    filled
                                                    chips
                                                    small-chips
                                                    no-data-text="Sin datos"
                                                    color="blue-grey lighten-2"
                                                    item-text="genombre"
                                                    item-value="geclave"
                                                    return-object
                                                    multiple>
                                        <template v-slot:selection="data">
                                            <v-chip v-bind="data.attrs"
                                                    small
                                                    :input-value="data.selected"
                                                    close
                                                    @click="data.select"
                                                    @click:close="removeGerencia(data.item,data.index)">
                                                {{ data.item.genombre }}
                                            </v-chip>
                                        </template>
                                        <template v-slot:item="data">
                                            <template v-if="typeof data.item !== 'object'">
                                                <v-list-item-content v-text="data.item"></v-list-item-content>
                                            </template>
                                            <template v-else>
                                                <v-list-item-content>
                                                    <v-list-item-title v-html="data.item.genombre"></v-list-item-title>
                                                </v-list-item-content>
                                            </template>
                                        </template>
                                    </v-autocomplete>
                                </div>


                                <span style="font-weight: bold;">Rango de fechas</span>
                                <v-row align="center">
                                    <v-col sm="5" md="5">
                                        <div class="mt-2">
                                            <v-dialog ref="dialog"
                                                      v-model="modalIni"
                                                      :return-value.sync="datos.fechaIni"
                                                      persistent
                                                      width="290px">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="datos.fechaIni"
                                                                  readonly
                                                                  :rules="ruleSelect"
                                                                  outlined
                                                                  dense
                                                                  v-bind="attrs"
                                                                  v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="datos.fechaIni"
                                                               type="month"
                                                               locale="es-mx"
                                                               :max="maxfecha"
                                                               :rules="ruleSelect"
                                                               scrollable>
                                                    <v-spacer></v-spacer>
                                                    <v-btn text
                                                           color="primary"
                                                           @click="modalIni = false">
                                                        Cancel
                                                    </v-btn>
                                                    <v-btn text
                                                           color="primary"
                                                           @click="$refs.dialog.save(datos.fechaIni)">
                                                        OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-dialog>
                                        </div>

                                    </v-col>
                                    <v-col sm="2" md="2">
                                        <center>
                                            <span>al</span>
                                        </center>

                                    </v-col>
                                    <v-col sm="5" md="5">
                                        <div class="mt-2">
                                            <v-dialog ref="dialog2"
                                                      v-model="modalFin"
                                                      :return-value.sync="datos.fechaFin"
                                                      persistent
                                                      width="290px">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="datos.fechaFin"
                                                                  readonly
                                                                  :disabled="!datos.fechaIni != ''"
                                                                  outlined
                                                                  :rules="ruleSelect"
                                                                  dense
                                                                  v-bind="attrs"
                                                                  v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="datos.fechaFin"
                                                               type="month"
                                                               locale="es-mx"
                                                               :rules="ruleSelect"
                                                               :max="maxfecha"
                                                               :min="minFechaFin"
                                                               scrollable>
                                                    <v-spacer></v-spacer>
                                                    <v-btn text
                                                           color="primary"
                                                           @click="modalFin = false">
                                                        Cancel
                                                    </v-btn>
                                                    <v-btn text
                                                           color="primary"
                                                           @click="$refs.dialog2.save(datos.fechaFin)">
                                                        OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-dialog>
                                        </div>





                                    </v-col>

                                </v-row>
                                <div>
                                    <span style="font-weight: bold;">Agrupar</span>
                                    <v-switch v-model="datos.agrupacion"
                                              value="1"></v-switch>
                                </div>

                            </v-col>

                        </v-row>



                        <v-col md="12">
                            <v-row justify="center">
                                <v-btn class="ma-2"
                                       color="primary"
                                       title="Buscar"
                                       :disabled="disabledSave"
                                       @click="drawChart()">
                                    <span style='color: white;'>Buscar</span>
                                </v-btn>
                                <v-btn dark
                                       class="ma-2"
                                       color="#B0BEC5"
                                       title="Limpiar"
                                       @click="limpiarclick()"
                                       :disabled="disabledSave">
                                    <span style='color: white;'>Limpiar</span>
                                </v-btn>
                            </v-row>
                        </v-col>


                    </v-card-text>


                </v-form>
            </v-card>

            <v-card elevation="6" class="base-card-container pa-0 mt-4">
                <v-card-title class="pa-5 pb-3 primary">
                    <p style="color: white;">Gráfica</p>
                </v-card-title>
                <v-card-text v-if="showCard">
                    <v-row justify="center">
                        <v-col cols="12">
                            <div id="div1">
                                <div ref="chartContainer" style="width: 100%; height: 600px;"></div>
                            </div>

                        </v-col>
                    </v-row>


                </v-card-text>
            </v-card>


        </div>
    </v-container>
</template>
<script>
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    //import apexchart from 'vue-apexcharts'
    import Calidad from "@/services/Calidad/Calidad.service.js";
    import 'anychart/dist/css/anychart-ui.min.css'; // Importa los estilos CSS de AnyChart
    import anychart from 'anychart'; // Importa AnyChart
    import { mapActions, mapMutations, mapState, mapGetters } from "vuex";

    export default {
        //components: {
        //    apexchart
        //},
        title() {
            return this.$route.meta.title
        },
        data() {
            return {
                showCard: false,
                showcargando: false,
                modalIni: false,
                modalFin: false,
                maxfecha: '',
                minFechaFin: '',
                disabledSave: false,

                ruleSelect: [(v) => !!v || "Campo requerido"],
                encuestasArray: [],
                clientesArray: [],
                gerenciasArray: [],
                datos: {
                    tipoencuesta: null,
                    cliente: [],
                    gerencia: [],
                    fechaIni: '',
                    fechaFin: '',
                    agrupacion: null

                },

            }
        },
        watch: {
            'datos.fechaIni'(val) {

                this.datos.fechaFin = '';
                this.minFechaFin = val;
                //this.maxFechaFin = val;
            }

        },
        computed: {
            ...mapState({ drawer: (state) => state.drawer }),
            ...mapState(["domain", "informationPage"]),
        },
        methods: {
            remove(item,index) {
                //const index = this.datos.cliente.indexOf(item.clclave);
                if (index >= 0) this.datos.cliente.splice(index, 1)
            },

            removeGerencia(item, index) {
                if (index >= 0) this.datos.gerencia.splice(index, 1)
            },
            limpiarclick() {
                if (this.showCard){
                    this.$refs.chartContainer.innerHTML = '';
                }
                
                this.modalIni = false;
                this.modalFin = false;
                this.minFechaFin = '';
                this.datos.tipoencuesta = null;
                this.datos.cliente = [];
                this.datos.gerencia = [];
                this.datos.fechaIni = '';
                this.datos.fechaFin = '';
                this.datos.agrupacion = null;
                this.showCard = false;

                this.$refs.formBus.resetValidation();

            },
            async drawChart() {
                this.$refs.formBus.validate();

                if (!this.$refs.formBus.validate()) {
                    return
                }
                

                this.showCard = true;
                this.showcargando = true;

                await setTimeout(async () => {
                }, 500);

                this.$refs.chartContainer.innerHTML = '';
                // Obtén el contenedor del gráfico usando la referencia
                const container = this.$refs.chartContainer;
                let response = await Calidad.obtenerDatosGrafica(this);
                document.getElementById('div1').scrollIntoView();


                var data = anychart.data.set(response);

                // map data for the first series, take x from the zero column and value from the first column of data set
                var firstSeriesData = data.mapAs({ x: 0, value: 1 });

                // map data for the second series, take x from the zero column and value from the second column of data set
                var secondSeriesData = data.mapAs({ x: 0, value: 2 });

                // map data for the second series, take x from the zero column and value from the third column of data set
                var thirdSeriesData = data.mapAs({ x: 0, value: 3 });

                // create a chart
                var chart = anychart.column();
                //chart.width(500);//para hacer la gráfica mas pequeña
                var li = chart.line(data).name("NPS");
                //li.normal().stroke("#0066cc");
                li.normal().stroke("#0A21C8", 2, "10 5", "round");
                li.hovered().stroke("#0A21C8", 3, "10 5", "round");
                li.selected().stroke("#0A21C8", 4, "10 5", "round");

                if (response.length == 1) {
                    chart.barGroupsPadding(4); // para darle el tamaño entre graficas
                }

                // set series labels text template AQUÍ LE ASIGNO EL VALOR DEL NPS
                var tit = chart.getSeries(0).labels().enabled(true);
                tit.fontColor('#000000');
                tit.fontSize(15);


                // turn on chart animation
                chart.animation(true);

                // force chart to stack values by Y scale.
                chart.yScale().stackMode('percent');

                //TODO LO DEL TITULO VA AQUÍ

                if (this.datos.gerencia.length > 0) {

                    const nomgerencias = this.datos.gerencia.map(objeto => objeto.genombre).join(',');

                }
                let nomclientes = '';
                if (this.datos.cliente.length > 0) {
                     nomclientes = this.datos.cliente.map(objeto => objeto.clnombrecorto).join(',');


                }
                let encuesta = this.datos.tipoencuesta.egdesc;

                
                var title = chart.title();
                title.enabled(true);
                title.useHtml(true);

                title.text("<span style = 'color:#000000;font-size:30px;'>" + encuesta + " NPS Mensual </span><br><br>" + "<span style = 'color:#000000;font-size:20px;'>" + nomclientes + "</span>");





                // helper function to setup label settings for all series
                var setupSeries = function (series, name) {
                    series.name(name).stroke('2 #fff 1');
                    series.hovered().stroke('2 #fff 1');
                };

                // temp variable to store series instance
                var series;

                // create first series with mapped data
                series = chart.column(firstSeriesData);
                setupSeries(series, 'Detractores');
                series.normal().fill("#E24B26");
                var se1 = series.labels().enabled(true);
                se1.position('center');
                se1.format("{%value}%");
                se1.fontColor('#000000');
                se1.fontSize(12);
                series
                    .tooltip()
                    .positionMode('point')
                    .position('center-top')
                    .anchor('center-bottom')
                    .offsetX(0)
                    .offsetY(5)
                    .titleFormat('{%X}')
                    .format('{%SeriesName} : {%Value}{groupsSeparator: }%');


                // create second series with mapped data
                series = chart.column(secondSeriesData);
                setupSeries(series, 'Pasivos');
                series.normal().fill("#F1D552");
                var se2 = series.labels().enabled(true);
                se2.position('center');
                se2.format("{%value}%");
                se2.fontColor('#000000');
                se2.fontSize(12);
                series
                    .tooltip()
                    .positionMode('point')
                    .position('center-top')
                    .anchor('center-bottom')
                    .offsetX(0)
                    .offsetY(5)
                    .titleFormat('{%X}')
                    .format('{%SeriesName} : {%Value}{groupsSeparator: }%');



                // create third series with mapped data
                series = chart.column(thirdSeriesData);
                setupSeries(series, 'Promotores');
                series.normal().fill("#17C81F");
                var se3 = series.labels().enabled(true);
                se3.position('center');
                se3.format("{%value}%");
                se3.fontColor('#000000');
                se3.fontSize(12);
                series
                    .tooltip()
                    .positionMode('point')
                    .position('center-top')
                    .anchor('center-bottom')
                    .offsetX(0)
                    .offsetY(5)
                    .titleFormat('{%X}')
                    .format('{%SeriesName} : {%Value}{groupsSeparator: }%');

                chart.interactivity().hoverMode('by-x');
                chart.tooltip().titleFormat('{%X}').displayMode('union');

                // turn on legend
                chart.legend().enabled(true).fontSize(15);


                // set the titles of the axes
                var title1 = chart.xAxis().title();
                title1.enabled(true);
                title1.text("Meses");
                title1.fontColor('#000000');
                title1.fontSize(16);


                if (response.length > 5) {
                    chart.xAxis().labels().rotation(-90);
                }

                var title2 = chart.yAxis().title();
                title2.enabled(true);
                title2.text("Porcentaje %");
                title2.fontColor('#000000');
                title2.fontSize(16);

                chart.xAxis().labels().fontColor('#000000');
                chart.xAxis().labels().fontSize(12);
                chart.yAxis().labels().fontColor('#000000');
                chart.yAxis().labels().fontSize(12);
                //series1 = chart.bubble(data);


                // set data
                chart.data(data);

                // set primary value scale mode to stacked
                chart.yScale().stackMode("value");


                // set yAxis labels formatting, force it to add % to values
                chart.yAxis(0).labels().format('{%Value}%');


                // adjusting y scale minimum and maximum 
                chart.yScale().minimum(0);
                chart.yScale().maximum(100);

                chart.yScale().ticks().interval(10);


                // Dibuja el gráfico en el contenedor
                chart.container(container);
                chart.draw();
                this.showcargando = false;
            }
        },
          

        async mounted() {

            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "296"//modulo de calidad
            ).then((response) => {
                if (response.data.length == 0) {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                    return
                }
            });


            this.maxfecha = moment().subtract(1, 'months').format("YYYY[-]MM");
            
            Calidad.ObtenerTipoEncuestasGrafica(this);
            Calidad.ObtenerClientes(this);
            Calidad.ObtenerGerencias(this);

        }
    }


</script>
